import { render, staticRenderFns } from "./aReputationReviews.vue?vue&type=template&id=5ad61212&scoped=true"
import script from "./aReputationReviews.vue?vue&type=script&lang=js"
export * from "./aReputationReviews.vue?vue&type=script&lang=js"
import style0 from "./aReputationReviews.vue?vue&type=style&index=0&id=5ad61212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad61212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
